/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { WebApiCustomListsDtoCustomListItemFieldValueDto } from './WebApiCustomListsDtoCustomListItemFieldValueDto';
import {
    WebApiCustomListsDtoCustomListItemFieldValueDtoFromJSON,
    WebApiCustomListsDtoCustomListItemFieldValueDtoFromJSONTyped,
    WebApiCustomListsDtoCustomListItemFieldValueDtoToJSON,
} from './WebApiCustomListsDtoCustomListItemFieldValueDto';

/**
 * 
 * @export
 * @interface WebApiCustomListsDtoUpdateCustomListDto
 */
export interface WebApiCustomListsDtoUpdateCustomListDto {
    /**
     * 
     * @type {number}
     * @memberof WebApiCustomListsDtoUpdateCustomListDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof WebApiCustomListsDtoUpdateCustomListDto
     */
    name?: string | null;
    /**
     * 
     * @type {Array<WebApiCustomListsDtoCustomListItemFieldValueDto>}
     * @memberof WebApiCustomListsDtoUpdateCustomListDto
     */
    values?: Array<WebApiCustomListsDtoCustomListItemFieldValueDto> | null;
    /**
     * 
     * @type {number}
     * @memberof WebApiCustomListsDtoUpdateCustomListDto
     */
    listType?: number | null;
    /**
     * 
     * @type {number}
     * @memberof WebApiCustomListsDtoUpdateCustomListDto
     */
    updatedBy?: number | null;
}

/**
 * Check if a given object implements the WebApiCustomListsDtoUpdateCustomListDto interface.
 */
export function instanceOfWebApiCustomListsDtoUpdateCustomListDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function WebApiCustomListsDtoUpdateCustomListDtoFromJSON(json: any): WebApiCustomListsDtoUpdateCustomListDto {
    return WebApiCustomListsDtoUpdateCustomListDtoFromJSONTyped(json, false);
}

export function WebApiCustomListsDtoUpdateCustomListDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebApiCustomListsDtoUpdateCustomListDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'values': !exists(json, 'values') ? undefined : (json['values'] === null ? null : (json['values'] as Array<any>).map(WebApiCustomListsDtoCustomListItemFieldValueDtoFromJSON)),
        'listType': !exists(json, 'listType') ? undefined : json['listType'],
        'updatedBy': !exists(json, 'updatedBy') ? undefined : json['updatedBy'],
    };
}

export function WebApiCustomListsDtoUpdateCustomListDtoToJSON(value?: WebApiCustomListsDtoUpdateCustomListDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'values': value.values === undefined ? undefined : (value.values === null ? null : (value.values as Array<any>).map(WebApiCustomListsDtoCustomListItemFieldValueDtoToJSON)),
        'listType': value.listType,
        'updatedBy': value.updatedBy,
    };
}

